(function () {
    'use strict';

    angular.module('swif.openbase')

    .config(
        function($routeProvider) {
            'ngInject';
            $routeProvider.when('/configuration/specialday/table_view', {
                templateUrl: 'partials/openbase/specialday_table_view.html',
                controller: 'OpenbaseSpecialdaysController',
                reloadOnSearch: false,
                resolve: {
                    data: ['swifRouteService', function (route) {
                        return route.check({resources: ['ical']});
                    }]
                }
            });
    })

    .factory('openbaseSpecialdayService',
        function (swif, $http, $q) {
            'ngInject';
            var service = {};
            service.createCollection = function () {
                var filter = {};
                swif.data.sortOn(filter, 'id', 'ASC');
                return swif.collections.createOrUpdate('specialdays', 'specialday', filter);
            };
            service.getCollection = function () {
                return swif.collections.getCollection('specialdays');
            };
            service.callback = function (error, data) {
                service.getCollection().defaultActionCallback(error, data);
                if (!error) {
                    swif.date.load_special_days();
                }
                if (data.action.id === 'import') {
                    service.getCollection().getItems();
                    swif.message.addInfo('data imported successfully');
                }
            };
            service.importData = function (array) {
                var d = [];
                _.forEach(array, function (ev) {
                    if (ev.summary) {
                        d.push([
                            ev.summary,
                            ev.startDateStr,
                            ev.endDateStr ? ev.endDateStr : null
                        ]);
                    }
                });
                var fields = ['name', 'date_start', 'date_end'];
                if (!_.isEmpty(d)) {
                    return swif.data.callKw('specialday', 'import_data', [fields, d], {})
                    .then(function() {
                        return true;
                    }, function () {
                        return false;
                    });
                } else {
                    return $q.when(true);
                }
            };
            service.preValidate = function (data) {
                if (data.action.id === 'import') {
                    var deferred = [];
                    deferred.push(service.importData(data.model.events));
                    return $q.all(deferred).then(function (c) {
                        var preValidated = true;
                        _.forEach(c, function (preV) {
                            preValidated = preValidated && preV;
                        });
                        return preValidated;
                    });
                } else {
                    return service.getCollection().preValidate(data);
                }
            };
            service.preModal = function (data) {
                service.getCollection().preModal(data);
                if (data.action.id === 'import') {
                    data.model = {
                        events: []
                    };
                }
            };
            return service;
        }
    )

    .controller('OpenbaseSpecialdaysController',
        function ($scope, openbaseSpecialdayService) {
            'ngInject';
            openbaseSpecialdayService.createCollection().then(function (collection) {
                $scope.specialdays = collection;
            });
            $scope.callback = openbaseSpecialdayService.callback;
            $scope.preValidate = openbaseSpecialdayService.preValidate;
            $scope.preModal = openbaseSpecialdayService.preModal;
        }
    )

    .controller('OpenbaseSpecialdaysImportController',
        function ($scope, $http, swif) {
            'ngInject';
            $scope.remove = function (array, item) {
                var index = array.indexOf(item);
                if (index > -1) {
                    array.splice(index, 1);
                }
            };
            $scope.sources = swif.settings.getContentType('specialday').sources;
            function download_ics(url, container) {
                $http.get(url).then(function (caldata) {
                    console.log(caldata.data);
                    var jcalData = ICAL.parse(caldata.data);
                    var vcalendar = new ICAL.Component(jcalData);
                    var vevents = vcalendar.getAllSubcomponents();
                    _.forEach(vevents, function (vevent) {
                        var eobject = new ICAL.Event(vevent);
                        if (!eobject.summary) {
                            return;
                        }
                        eobject.startDateStr = eobject.startDate.toString();
                        if (eobject.endDate && eobject.duration.days > 1) {
                            eobject.endDateStr = eobject.endDate.toString();
                            // for a more intuitive format : Holidays finishes on Sunday, not on Monday
                            if (eobject.endDateStr) {
                                eobject.endDateStr = moment(eobject.endDateStr, "YYYY-MM-DD").subtract(1,"days").format("YYYY-MM-DD");
                            }
                        }
                        if (eobject.isRecurring()) {
                            var iter = eobject.iterator();
                            var max;
                            var rt = eobject.getRecurrenceTypes();
                            if (rt.YEARLY) {
                                max = 10;
                            } else if (rt.MONTHLY) {
                                max = 12 * 3;
                            } else if (rt.WEEKLY) {
                                max = 52 * 3;
                            } else {
                                max = 0;
                            }
                            var i = 0;
                            var copy;
                            while (i <= max) {
                                i = i + 1;
                                copy = angular.copy(eobject);
                                copy.startDateStr = iter.next().toString();
                                delete copy.endDateStr;
                                container.push(copy);
                            }
                        } else {
                            container.push(eobject);
                        }
                    });
                });
            };
            $scope.$watch('model.selected', function (newV) {
                if (newV) {
                    $scope.model.events = [];
                    download_ics($scope.sources[newV].url, $scope.model.events);
                } else {
                    $scope.model.events = [];
                }
            });
        }
    );

})();
